import React, { useState, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Card, Col, Form, Row, Alert, Spinner, Container } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { 
  PersonBadge, 
  PersonCircle, 
  ShieldLock, 
  CheckCircle,
  ArrowRight,
  CurrencyDollar,
  FileText,
  Search,
  Phone,
  Lock,
  Envelope,
  Key,
  ArrowLeft,
  Globe2,
  ChevronRight,
  Star,
  Building,
  Cash,
  Shield,
  Award,
  BarChart,
  Headset,
  CloudCheck
} from "react-bootstrap-icons";

import bg1 from "../assets/img/imagecover.png";
import bg2 from "../assets/img/imagecover.png";
import bg3 from "../assets/img/imagecover.png";
import './Signin2.css';
import logo from "../assets/img/logo1.png";
import { textAlign } from "@mui/system";
import { API_BASE_URL } from "../constants/api_constants";

// ==================== DONNÉES FICTIVES DES PAYS ====================
const FALLBACK_COUNTRIES = [
  { id: 1, iso_alpha2: "GA", name_fr: "Gabon", phone_code: "+241", currency_code: "XAF", currency_name: "Franc CFA" },
  { id: 2, iso_alpha2: "CM", name_fr: "Cameroun", phone_code: "+237", currency_code: "XAF", currency_name: "Franc CFA" },
  { id: 3, iso_alpha2: "CI", name_fr: "Côte d'Ivoire", phone_code: "+225", currency_code: "XOF", currency_name: "Franc CFA" },
  { id: 4, iso_alpha2: "SN", name_fr: "Sénégal", phone_code: "+221", currency_code: "XOF", currency_name: "Franc CFA" },
  { id: 5, iso_alpha2: "BF", name_fr: "Burkina Faso", phone_code: "+226", currency_code: "XOF", currency_name: "Franc CFA" },
  { id: 6, iso_alpha2: "ML", name_fr: "Mali", phone_code: "+223", currency_code: "XOF", currency_name: "Franc CFA" },
  { id: 7, iso_alpha2: "NE", name_fr: "Niger", phone_code: "+227", currency_code: "XOF", currency_name: "Franc CFA" },
  { id: 8, iso_alpha2: "TD", name_fr: "Tchad", phone_code: "+235", currency_code: "XAF", currency_name: "Franc CFA" },
  { id: 9, iso_alpha2: "CF", name_fr: "Centrafrique", phone_code: "+236", currency_code: "XAF", currency_name: "Franc CFA" },
  { id: 10, iso_alpha2: "CG", name_fr: "Congo", phone_code: "+242", currency_code: "XAF", currency_name: "Franc CFA" },
  { id: 11, iso_alpha2: "CD", name_fr: "RDC", phone_code: "+243", currency_code: "CDF", currency_name: "Franc Congolais" },
  { id: 12, iso_alpha2: "GQ", name_fr: "Guinée Éq.", phone_code: "+240", currency_code: "XAF", currency_name: "Franc CFA" },
  { id: 13, iso_alpha2: "FR", name_fr: "France", phone_code: "+33", currency_code: "EUR", currency_name: "Euro" },
  { id: 14, iso_alpha2: "BE", name_fr: "Belgique", phone_code: "+32", currency_code: "EUR", currency_name: "Euro" },
  { id: 15, iso_alpha2: "CH", name_fr: "Suisse", phone_code: "+41", currency_code: "CHF", currency_name: "Franc Suisse" },
  { id: 16, iso_alpha2: "CA", name_fr: "Canada", phone_code: "+1", currency_code: "CAD", currency_name: "Dollar Canadien" }
];

export default function Signin2() {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    otp: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [debugInfo, setDebugInfo] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
  const [countries, setCountries] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [showCountryPage, setShowCountryPage] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [loginError, setLoginError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [pendingCredentials, setPendingCredentials] = useState(null);
  const [usingFallback, setUsingFallback] = useState(false);
  const [isConnecting, setIsConnecting] = useState(false);
  const API_URL = API_BASE_URL;

  // ============================================================
  // ✅ FONCTION DE REDIRECTION APRÈS CONNEXION
  // ============================================================
  const handleRedirect = (user, userRoles) => {
    // Extraire les informations de l'utilisateur
    const userRoleId = user?.role_id;
    const userMarcheId = user?.id_marche;
    const hasMarket = !!userMarcheId;
    
    // Vérifier les rôles
    const isSuperAdmin = userRoles && Array.isArray(userRoles) 
      ? userRoles.some(role => role.name === 'super_admin') 
      : false;
    
    const isAdminPrincipal = userRoleId === 1003;
    const isAdminMarche = userRoleId === 1005;
    const isSuperviseur = userRoleId === 1007;
    const isAgent = userRoleId === 1012 || userRoleId === 1013;
    const isCollecteur = userRoleId === 1013;
    
    console.log("🔀 Redirection - Infos utilisateur:", {
      role_id: userRoleId,
      hasMarket,
      isSuperAdmin,
      isAdminPrincipal,
      isAdminMarche,
      isSuperviseur,
      isAgent,
      isCollecteur
    });
    
    // ✅ LOGIQUE DE REDIRECTION
    
    // 1. SUPER ADMIN
    if (isSuperAdmin) {
      console.log("➡️ Super Admin → /dashboard");
      return '/dashboard';
    }
    
    // 2. ADMIN PRINCIPAL (ODD/Commune) - role_id = 1003
    if (isAdminPrincipal) {
      console.log("➡️ Admin Principal → /consolidated/dashboard");
      return '/consolidated/dashboard';
    }
    
    // 3. ADMIN MARCHÉ - role_id = 1005
    if (isAdminMarche) {
      if (hasMarket) {
        console.log("➡️ Admin Marché avec marché → /supervisor/dashboard");
        return '/supervisor/dashboard';
      }
      console.log("➡️ Admin Marché sans marché → /dashboard");
      return '/dashboard';
    }
    
    // 4. SUPERVISEUR - role_id = 1007
    if (isSuperviseur) {
      if (hasMarket) {
        console.log("➡️ Superviseur avec marché → /supervisor/dashboard");
        return '/supervisor/dashboard';
      }
      console.log("➡️ Superviseur sans marché → /dashboard");
      return '/dashboard';
    }
    
    // 5. AGENT - role_id = 1012
    if (isAgent) {
      if (hasMarket) {
        console.log("➡️ Agent avec marché → /supervisor/dashboard");
        return '/supervisor/dashboard';
      }
      console.log("➡️ Agent sans marché → /dashboard");
      return '/supervisor/dashboard';
    }
    
    // 6. COLLECTEUR - role_id = 1013
    if (isCollecteur) {
      if (hasMarket) {
        console.log("➡️ Collecteur avec marché → /supervisor/dashboard");
        return '/supervisor/dashboard';
      }
      console.log("➡️ Collecteur sans marché → /dashboard");
      return '/supervisor/dashboard';
    }
    
    // 7. DEFAUT
    console.log("➡️ Par défaut → /dashboard");
    return '/dashboard';
  };

  const storeSessionData = (token, apidomain, refreshToken, userData, default_currency, country_code, def_type_localite, userRoles) => {
    sessionStorage.setItem("apidomain", apidomain);
    sessionStorage.setItem("authToken", token);
    sessionStorage.setItem("country_code", country_code);
    sessionStorage.setItem("refreshToken", refreshToken);
    sessionStorage.setItem("userData", JSON.stringify(userData));
    sessionStorage.setItem("userRoles", JSON.stringify(userRoles));
    sessionStorage.setItem("is_authenticated", "true");
    sessionStorage.setItem("login_time", new Date().toISOString());
    sessionStorage.setItem("tokenExpiry", new Date().getTime() + (3600 * 1000));
    sessionStorage.setItem("default_currency", default_currency);
    sessionStorage.setItem("def_type_localite", def_type_localite);
  };

  const getFlagEmoji = (countryCode) => {
    if (!countryCode) return '🌍';
    const codePoints = countryCode.toUpperCase().split('').map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  };

  const fetchCountries = useCallback(async () => {
    setLoadingCountries(true);
    setUsingFallback(false);
    try {
      const token = sessionStorage.getItem("authToken");
      const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const response = await fetch(`${API_URL}/countries`, { method: 'GET', headers });
      if (!response.ok) throw new Error(`Erreur HTTP ${response.status}`);
      const data = await response.json();
      if (data.code === 200 && Array.isArray(data.countries) && data.countries.length > 0) {
        setCountries(data.countries);
      } else {
        throw new Error('Format de réponse invalide');
      }
    } catch (error) {
      console.error('Erreur chargement pays, utilisation des données fictives:', error);
      setCountries(FALLBACK_COUNTRIES);
      setUsingFallback(true);
    } finally {
      setLoadingCountries(false);
    }
  }, [API_URL]);

  // Fonction corrigée pour la sélection du pays
  const handleCountrySelect = async (country) => {
    setSelectedCountry(country);
    setIsConnecting(true);
    
    if (pendingCredentials) {
      await performLogin(pendingCredentials, country);
    }
    
    setIsConnecting(false);
  };

  // Fonction performLogin corrigée
  const performLogin = async (creds, country) => {
    setLoading(true);
    setLoginError("");
    
    try {
      const requestBody = {
        username: creds.username,
        password: creds.password,
        otp: creds.otp,
        phone_code: country.phone_code,
        country_code: country.iso_alpha2,
        country_name: country.name_fr
      };
      
      console.log(`
========== COPY THIS FOR POSTMAN ==========

URL: ${API_URL}/bo/login

METHOD: POST

HEADERS:
Content-Type: application/json
Accept: application/json

BODY (raw JSON):
${JSON.stringify({
  username: creds.username,
  password: creds.password,
  otp: creds.otp,
  phone_code: country.phone_code,
  country_code: country.iso_alpha2,
  country_name: country.name_fr
}, null, 2)}

===========================================
`);
      
      const response = await fetch(`${API_URL}/bo/login`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Accept': 'application/json' 
        },
        body: JSON.stringify(requestBody)
      });
      
      const data = await response.json();
      
      console.log("📡 Réponse API:", { status: response.status, data });
      
      if (response.ok && data.success === 200) {
        sessionStorage.setItem("selectedCountry", JSON.stringify(country));
        sessionStorage.setItem("phone_code", country.phone_code);
        sessionStorage.setItem("country_code", country.iso_alpha2);
        storeSessionData(
          data.token, 
          data.apidomain, 
          data.refresh_token, 
          data.user, 
          data.default_currency, 
          country.iso_alpha2 || data.country_code, 
          data.def_type_localite,
          data.userRoles
        );

        console.log("✅ Utilisateur connecté:", data.user);
        console.log("✅ Rôles:", data.userRoles);
        
        // ✅ Déterminer la redirection
        const redirectPath = handleRedirect(data.user, data.userRoles);
        console.log(`🔀 Redirection vers: ${redirectPath}`);
        
        setSuccess("Connexion réussie ! Redirection...");
        
        setTimeout(() => {
          navigate(redirectPath);
        }, 1500);
        
        setLoading(false);
        return;
      } else {
        setLoginError(data.message || "Identifiants incorrects.");
        setTimeout(() => { 
          setShowCountryPage(false); 
          setPendingCredentials(null); 
          setError("Identifiants incorrects. Veuillez réessayer.");
          setLoading(false);
          setIsConnecting(false);
        }, 2000);
        return;
      }
    } catch (err) {
      console.error("❌ Erreur réseau:", err);
      setLoginError(`Erreur réseau : ${err.message}`);
      setTimeout(() => { 
        setShowCountryPage(false); 
        setPendingCredentials(null); 
        setError(`Erreur: ${err.message}`);
        setLoading(false);
        setIsConnecting(false);
      }, 2000);
      return;
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    
    if (!credentials.username || !credentials.password) {
      setError("Veuillez saisir votre identifiant et mot de passe");
      return;
    }
    setLoginError("");
    setLoading(true);
    setPendingCredentials({
      username: credentials.username,
      password: credentials.password,
      otp: credentials.otp
    });
    
    await fetchCountries();
    setShowCountryPage(true);
  };

  const filteredCountries = countries.filter(country =>
    country.name_fr.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (country.currency_code && country.currency_code.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Page de sélection du pays
  if (showCountryPage) {
    return (
      <div style={countrySelectorStyles.container}>
        <div style={countrySelectorStyles.overlay}>
          <Container fluid style={{ maxWidth: '1400px' }}>
            <Row className="justify-content-center align-items-start" style={{ minHeight: '100vh', paddingTop: '0rem', paddingBottom: '2rem' }}>
              <Col lg={8} md={10} sm={12}>
                <div style={countrySelectorStyles.card}>
                  {usingFallback && (
                    <div style={countrySelectorStyles.fallbackBadge}>
                      <Globe2 size={14} style={{ marginRight: '8px' }} />
                      Choisir votre pays pour continuer...
                    </div>
                  )}
                  
                  <div style={countrySelectorStyles.header}>
                    <div style={countrySelectorStyles.iconContainer}>
                      <div style={countrySelectorStyles.iconGlow}>
                        <Globe2 size={28} style={countrySelectorStyles.headerIcon} />
                      </div>
                    </div>
                    <h2 style={countrySelectorStyles.title}>Sélectionnez votre pays</h2>
                    <p style={countrySelectorStyles.subtitle}>Choisissez le pays où est située votre entité</p>
                    {isConnecting && (
                      <div style={{ textAlign: 'center', marginTop: '16px' }}>
                        <Spinner animation="border" variant="primary" size="sm" />
                        <span style={{ marginLeft: '8px', fontSize: '13px', color: '#718096' }}>
                          Connexion en cours...
                        </span>
                      </div>
                    )}
                    {pendingCredentials && (
                      <div style={countrySelectorStyles.userCard}>
                        <div style={countrySelectorStyles.userAvatar}>
                          <PersonCircle size={18} />
                        </div>
                        <div style={countrySelectorStyles.userInfo}>
                          <span style={countrySelectorStyles.userLabel}>Connexion pour</span>
                          <span style={countrySelectorStyles.userEmail}>{pendingCredentials.username}</span>
                        </div>
                        <Button variant="link" size="sm" style={countrySelectorStyles.changeLink} onClick={() => { setShowCountryPage(false); setLoading(false); setPendingCredentials(null); }}>
                          Modifier
                        </Button>
                      </div>
                    )}
                  </div>

                  {loginError && (
                    <div style={countrySelectorStyles.errorContainer}>
                      <span style={countrySelectorStyles.errorIcon}>⚠️</span>
                      <div>
                        <strong style={countrySelectorStyles.errorTitle}>Échec de connexion</strong>
                        <p style={countrySelectorStyles.errorMessage}>{loginError}</p>
                      </div>
                    </div>
                  )}

                  {success && (
                    <div style={countrySelectorStyles.successContainer}>
                      <CheckCircle size={20} style={countrySelectorStyles.successIcon} />
                      <div>
                        <strong>{success}</strong>
                        <div style={{ marginTop: '6px' }}><Spinner animation="border" size="sm" variant="success" /></div>
                      </div>
                    </div>
                  )}

                  <div style={countrySelectorStyles.searchContainer}>
                    <input 
                      type="text" 
                      placeholder="Rechercher un pays..." 
                      value={searchTerm} 
                      onChange={(e) => setSearchTerm(e.target.value)} 
                      style={countrySelectorStyles.searchInput} 
                    />
                  </div>

                  <div style={countrySelectorStyles.body}>
                    {loadingCountries ? (
                      <div style={countrySelectorStyles.loaderContainer}>
                        <Spinner animation="border" variant="primary" size="lg" />
                        <p>Chargement des pays...</p>
                      </div>
                    ) : (
                      <Row style={countrySelectorStyles.countriesGrid}>
                        {filteredCountries.map((country, index) => (
                          <Col md={6} key={country.id} style={{ marginBottom: '12px' }}>
                            <div
                              style={{ 
                                ...countrySelectorStyles.countryItem, 
                                animationDelay: `${index * 0.02}s`,
                                opacity: isConnecting && selectedCountry?.id === country.id ? 0.6 : 1,
                                pointerEvents: isConnecting ? 'none' : 'auto'
                              }}
                              onClick={() => !isConnecting && handleCountrySelect(country)}
                              className="country-card-animated"
                            >
                              <div style={countrySelectorStyles.countryFlagWrapper}>
                                <span style={countrySelectorStyles.countryFlag}>{getFlagEmoji(country.iso_alpha2)}</span>
                              </div>
                              <div style={countrySelectorStyles.countryInfo}>
                                <div style={countrySelectorStyles.countryName}>{country.name_fr}</div>
                                <div style={countrySelectorStyles.countryMeta}>
                                  <span style={countrySelectorStyles.phoneCode}>{country.phone_code}</span>
                                  <span style={countrySelectorStyles.metaSeparator}>•</span>
                                  <span style={countrySelectorStyles.currencyCode}>{country.currency_code}</span>
                                </div>
                              </div>
                              {isConnecting && selectedCountry?.id === country.id ? (
                                <Spinner size="sm" animation="border" variant="primary" />
                              ) : (
                                <ChevronRight size={16} style={countrySelectorStyles.countryArrow} />
                              )}
                            </div>
                          </Col>
                        ))}
                        {filteredCountries.length === 0 && !loadingCountries && (
                          <Col xs={12}>
                            <div style={countrySelectorStyles.emptyState}>
                              <Globe2 size={48} style={{ opacity: 0.3, marginBottom: '16px' }} />
                              <p>Aucun pays trouvé</p>
                            </div>
                          </Col>
                        )}
                      </Row>
                    )}
                  </div>

                  <div style={countrySelectorStyles.footer}>
                    <div style={countrySelectorStyles.footerNote}>
                      <Cash size={14} style={{ marginRight: '6px', opacity: 0.7 }} />
                      <span>La devise sera adaptée automatiquement selon votre sélection</span>
                    </div>
                    <Button variant="link" onClick={() => { setShowCountryPage(false); setLoading(false); setPendingCredentials(null); }} style={countrySelectorStyles.backButton}>
                      ← Retour à la connexion
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }

  // ============================================================
  // PAGE DE SÉLECTION DU PROFIL
  // ============================================================
  if (!userType) {
    return (
      <div className="page-sign d-block py-0" style={styles.page}>
        <Row className="g-0 min-vh-100">
          <Col md="7" lg="8" xl="9" className="d-none d-lg-block">
            <div style={{
              ...styles.imageContainer,
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${bg3})`
            }}>
              <div style={styles.imageOverlay}>
                <div style={styles.heroContent}>
                  <div style={styles.logoContainer}>
                    <div style={styles.logoWrapper}>
                      <img src={logo} alt="SyncTax Logo" style={styles.logoImage} />
                    </div>
                    <h1 style={styles.heroTitle}>Sync<span style={{color: '#3498db'}}>Tax</span></h1>
                  </div>
                  <h2 style={styles.heroSubtitle}>L'Excellence dans la <span style={styles.highlight}>Gestion Fiscale</span></h2>
                  <p style={styles.heroDescription}>Une plateforme dédiée à l'enrôlement et à la collecte des taxes, alliant performance, sécurité et simplicité d'utilisation.</p>
                </div>
              </div>
            </div>
          </Col>
          <Col md="5" lg="4" xl="3" className="col-wrapper">
            <Card className="card-sign" style={styles.card}>
              <Card.Header style={styles.cardHeader}>
                <div style={styles.logoContainerCompact}>
                  <br />
                  <div style={styles.welcomeSection}>
                    <Card.Title style={styles.title}>Bienvenue</Card.Title>
                    <Card.Text style={styles.subtitle}>Choisissez votre profil pour accéder à la plateforme</Card.Text>
                  </div>
                </div>
              </Card.Header>
              <Card.Body style={styles.cardBody}>
                <div style={styles.userSelectionMinimal}>
                  <div style={styles.userChoiceMinimalAgent} onClick={() => setUserType("agent")}>
                    <div style={styles.choiceHeader}>
                      <div style={styles.choiceIconWrapperAgent}><PersonBadge style={styles.choiceIconAgent} /></div>
                      <div style={styles.choiceLabels}><span style={styles.choiceTitle}>Agent Fiscal</span><span style={styles.choiceSubtitle}>Espace professionnel</span></div>
                      <ArrowRight style={styles.choiceArrowAgent} />
                    </div>
                  </div>
                  <div style={styles.userChoiceMinimalUser} onClick={() => setUserType("taxpayer")}>
                    <div style={styles.choiceHeader}>
                      <div style={styles.choiceIconWrapperUser}><PersonCircle style={styles.choiceIconUser} /></div>
                      <div style={styles.choiceLabels}><span style={styles.choiceTitle}>Usager</span><span style={styles.choiceSubtitle}>Espace contribuable</span></div>
                      <ArrowRight style={styles.choiceArrowUser} />
                    </div>
                  </div>
                </div>
              </Card.Body>
              <Card.Footer style={styles.cardFooter}>
                <div style={styles.securitySection}>  
                  <div style={styles.securityDetails}>
                    <div style={styles.securityItem}><div style={styles.securityDot}></div><span style={styles.securityText}>Minerve-Tech | © Tous droits réservés. V1.1</span></div>
                  </div>
                </div>
                {debugInfo && (<div style={{ marginTop: '1rem', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px', fontSize: '0.7rem', fontFamily: 'monospace', whiteSpace: 'pre-wrap', maxHeight: '200px', overflowY: 'auto' }}>{debugInfo}</div>)}
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  // ============================================================
  // PAGE DE CONNEXION
  // ============================================================
  return (
    <div className="page-sign d-block py-0" style={styles.page}>
      <Row className="g-0 min-vh-100">
        <Col md="7" lg="8" xl="9" className="d-none d-lg-block">
          <div style={{
            ...styles.imageContainer,
            backgroundImage: userType === "agent" ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bg2})` : `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bg1})`,
            backgroundSize: 'cover', backgroundPosition: 'center'
          }}>
            <div style={styles.loginHeroContent}>
              <div style={styles.loginHeroIcon}>{userType === "agent" ? <PersonBadge /> : <PersonCircle />}</div>
              <h2 style={styles.loginHeroTitle}>{userType === "agent" ? "Espace Agent Fiscal" : "Espace Contribuable"}</h2>
              <p style={styles.loginHeroSubtitle}>{userType === "agent" ? "Gérez l'enrôlement et la collecte des taxes" : "Consultez et payez vos taxes en toute sécurité"}</p>
              <div style={styles.featuresList}>
                {userType === "agent" ? (
                  <>
                    <div style={styles.featureItemLogin}><FileText style={styles.featureIconLogin} /><span>Enregistrement des usagers</span></div>
                    <div style={styles.featureItemLogin}><CurrencyDollar style={styles.featureIconLogin} /><span>Collecte des taxes</span></div>
                    <div style={styles.featureItemLogin}><Search style={styles.featureIconLogin} /><span>Recherche avancée</span></div>
                  </>
                ) : (
                  <>
                    <div style={styles.featureItemLogin}><Phone style={styles.featureIconLogin} /><span>Paiement mobile</span></div>
                    <div style={styles.featureItemLogin}><FileText style={styles.featureIconLogin} /><span>Consultation des taxes</span></div>
                    <div style={styles.featureItemLogin}><ShieldLock style={styles.featureIconLogin} /><span>Sécurité garantie</span></div>
                  </>
                )}
              </div>
            </div>
          </div>
        </Col>
        <Col md="5" lg="4" xl="3" className="col-wrapper">
          <Card className="card-sign" style={styles.loginCard}>
            <Card.Header style={styles.loginCardHeader}>
              <Button variant="link" style={styles.backButton} onClick={() => { setUserType(""); setError(""); setSuccess(""); setDebugInfo(""); }}><ArrowLeft style={{marginRight: '6px'}} />Retour</Button>
              <div style={styles.loginHeaderContent}>
                <div style={{ ...styles.userTypeIndicatorCompact, backgroundColor: userType === "agent" ? '#3498db' : '#2ecc71' }}>{userType === "agent" ? <PersonBadge /> : <PersonCircle />}</div>
                <div><Card.Title style={styles.loginTitle}>Connexion {userType === "agent" ? "Agent" : "Usager"}</Card.Title><Card.Text style={styles.loginSubtitle}>{userType === "agent" ? "Accédez à votre espace de gestion" : "Accédez à votre espace contribuable"}</Card.Text></div>
              </div>
            </Card.Header>
            <Card.Body style={styles.loginCardBody}>
              <br />
              {error && (<Alert variant="danger" style={styles.alertMessage}><Alert.Heading style={styles.alertHeading}>Erreur de connexion</Alert.Heading><div style={{ fontSize: '0.9rem' }}>{error}</div></Alert>)}
              {success && (<Alert variant="success" className="text-center border-success shadow-sm" style={{ ...styles.alertMessage, borderLeft: '4px solid #198754', animation: 'fadeIn 0.5s ease-out' }}><div className="d-flex flex-column align-items-center"><CheckCircle className="mb-3" style={{ ...styles.successIcon, fontSize: '3rem', animation: 'scaleIn 0.3s ease-out 0.1s both' }} /><Alert.Heading className="h5 fw-bold mb-2" style={styles.alertHeading}>Succès</Alert.Heading><p className="text-muted mb-0" style={styles.alertText}>{success}</p></div></Alert>)}
              <Form onSubmit={handleLogin}>
                <div style={styles.formGroup}><Form.Label style={styles.formLabel}><Envelope style={styles.inputIcon} />Identifiant</Form.Label><Form.Control type="text" placeholder="email@email.com" value={credentials.username} onChange={(e) => setCredentials({...credentials, username: e.target.value})} required disabled={loading || success} style={styles.formInput} /></div>
                <div style={styles.formGroup}>
                  <Form.Label style={styles.formLabel}><Key style={styles.inputIcon} />Mot de passe</Form.Label>
                  <div style={styles.passwordInputWrapper}>
                    <Form.Control type={showPassword ? "text" : "password"} placeholder="Mtech@2025" value={credentials.password} onChange={(e) => setCredentials({...credentials, password: e.target.value})} required disabled={loading || success} style={{...styles.formInput, paddingRight: '45px'}} />
                    <Button type="button" variant="link" onClick={() => setShowPassword(!showPassword)} style={styles.togglePasswordButton} title={showPassword ? "Masquer" : "Afficher"} disabled={loading || success}>{showPassword ? <EyeSlash style={styles.togglePasswordIcon} /> : <Eye style={styles.togglePasswordIcon} />}</Button>
                  </div>
                  <div className="text-end mt-2"><Link to="/forgot-password" style={styles.forgotPasswordLink}>Mot de passe oublié ?</Link></div>
                </div>
                <Button type="submit" variant="primary" className="w-100" disabled={loading || userType !== "agent"} style={{ ...styles.loginButton, backgroundColor: userType === "agent" ? '#3498db' : '#2ecc71', background: userType === "agent" ? 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)' : 'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)', opacity: (loading || success) ? 0.7 : 1 }}>
                  {loading ? (<><span className="spinner-border spinner-border-sm me-2" role="status"></span>Connexion...</>) : success ? "Connexion réussie !" : "Se connecter"}
                </Button>
              </Form>
            </Card.Body>
            <Card.Footer style={styles.loginCardFooter}><div style={styles.securityInfo}><Lock style={styles.securityIconFooter} /><span style={styles.securityTextFooter}>Connexion sécurisée SSL/TLS</span></div></Card.Footer>
          </Card>
        </Col>
      </Row>
    </div>
  );
}



// ==================== STYLES DE LA PAGE DE SÉLECTION (VERSION LARGE) ====================
const countrySelectorStyles = {
  container: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10000, overflowY: 'auto', backgroundColor: '#f0f2f5' },
  overlay: { minHeight: '100vh', padding: '2rem' },
  
  // Panneau d'information - version améliorée
  infoPanel: { 
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)', 
    borderRadius: '28px', 
    padding: '40px 32px', 
    boxShadow: '0 20px 40px -12px rgba(0,0,0,0.1)',
    height: '100%',
    position: 'relative',
    overflow: 'hidden'
  },
  logoSection: { 
    textAlign: 'center', 
    marginBottom: '24px' 
  },
  logoWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100px',
    height: '100px',
    background: 'white',
    borderRadius: '24px',
    boxShadow: '0 10px 25px -5px rgba(52,152,219,0.2)',
    marginBottom: '20px',
    padding: '16px'
  },
  infoLogo: { 
    width: '100%', 
    height: '100%', 
    objectFit: 'contain' 
  },
  infoTitle: { 
    fontSize: '32px', 
    fontWeight: '800', 
    margin: 0, 
    color: '#1a202c',
    letterSpacing: '-0.5px'
  },
  certBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    background: '#e8f4fd',
    padding: '6px 14px',
    borderRadius: '30px',
    fontSize: '12px',
    fontWeight: '500',
    color: '#3498db',
    marginBottom: '20px',
    width: 'fit-content'
  },
  infoDescription: { 
    fontSize: '14px', 
    color: '#4a5568', 
    lineHeight: 1.6, 
    marginBottom: '28px' 
  },
  featuresList: { 
    marginBottom: '32px' 
  },
  featureItem: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '12px', 
    padding: '10px 0', 
    fontSize: '14px', 
    color: '#2d3748',
    borderBottom: '1px solid #edf2f7'
  },
  featureIconWrapper: {
    width: '28px',
    height: '28px',
    background: '#e8f4fd',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  featureIcon: { 
    color: '#3498db' 
  },
  divider: {
    height: '1px',
    background: 'linear-gradient(90deg, transparent, #e2e8f0, transparent)',
    margin: '24px 0'
  },
  statsSection: { 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    gap: '16px'
  },
  statLine: {
    width: '1px',
    height: '30px',
    background: '#e2e8f0'
  },
  statItem: { 
    textAlign: 'center', 
    flex: 1 
  },
  statNumber: { 
    display: 'block', 
    fontSize: '24px', 
    fontWeight: '700', 
    color: '#2c3e50' 
  },
  statLabel: { 
    display: 'block', 
    fontSize: '11px', 
    color: '#718096', 
    marginTop: '4px' 
  },
  
  // Le reste des styles inchangé...
  card: { backgroundColor: 'white', borderRadius: '28px', boxShadow: '0 20px 40px -12px rgba(0,0,0,0.15)', overflow: 'hidden' },
  fallbackBadge: { display: 'inline-flex', alignItems: 'center', background: '#fef3c7', padding: '4px 12px', borderRadius: '20px', fontSize: '11px', color: '#d97706', margin: '16px 24px 0' },
  header: { padding: '28px 28px 20px', textAlign: 'center' },
  iconContainer: { marginBottom: '16px', display: 'flex', justifyContent: 'center' },
  iconGlow: { width: '56px', height: '56px', background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)', borderRadius: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 16px rgba(52,152,219,0.3)' },
  headerIcon: { color: 'white' },
  title: { fontSize: '22px', fontWeight: '700', marginBottom: '6px', color: '#1a202c' },
  subtitle: { fontSize: '13px', color: '#718096', marginBottom: '20px' },
  userCard: { background: '#f7fafc', borderRadius: '12px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '10px', marginTop: '12px' },
  userAvatar: { width: '32px', height: '32px', background: '#e2e8f0', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4a5568' },
  userLabel: { fontSize: '10px', color: '#718096', display: 'block',textAlign:'left' },
  userEmail: { fontSize: '12px', fontWeight: '600', color: '#2d3748' },
  changeLink: { fontSize: '11px', color: '#3498db', textDecoration: 'none', marginLeft: 'auto', padding: 0 },
  searchContainer: { padding: '12px 24px 0', position: 'relative' },
  searchInput: { width: '100%', padding: '10px 38px 10px 14px', border: '1px solid #e2e8f0', borderRadius: '12px', fontSize: '13px', outline: 'none', transition: 'all 0.2s' },
  searchIcon: { position: 'absolute', right: '36px', top: '50%', transform: 'translateY(-50%)', fontSize: '14px', opacity: 0.5 },
  body: { padding: '16px 24px', maxHeight: '260px', overflowY: 'auto' },
  countriesGrid: { margin: '-6px' },
  countryItem: { display: 'flex', alignItems: 'center', padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer', transition: 'all 0.25s ease', backgroundColor: '#fff', margin: '6px' },
  countryFlagWrapper: { marginRight: '14px' },
  countryFlag: { fontSize: '28px' },
  countryInfo: { flex: 1 },
  countryName: { fontSize: '14px', fontWeight: '600', color: '#1a202c', marginBottom: '2px' },
  countryMeta: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px' },
  phoneCode: { color: '#4a5568' },
  currencyCode: { color: '#48bb78', fontWeight: '500' },
  metaSeparator: { color: '#cbd5e0' },
  countryArrow: { color: '#cbd5e0', transition: 'transform 0.2s' },
  loaderContainer: { textAlign: 'center', padding: '40px', color: '#718096' },
  emptyState: { textAlign: 'center', padding: '40px', color: '#718096' },
  footer: { padding: '16px 24px', borderTop: '1px solid #e2e8f0', backgroundColor: '#fafbfc', textAlign: 'center' },
  footerNote: { fontSize: '11px', color: '#718096', marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  backButton: { fontSize: '12px', color: '#3498db', textDecoration: 'none', padding: 0 },
  errorContainer: { margin: '12px 24px', padding: '12px 14px', backgroundColor: '#fff5f5', borderRadius: '12px', border: '1px solid #fed7d7', display: 'flex', gap: '10px' },
  errorIcon: { fontSize: '18px' },
  errorTitle: { fontSize: '12px', color: '#c53030', display: 'block', marginBottom: '2px' },
  errorMessage: { fontSize: '11px', color: '#742a2a', marginBottom: 0 },
  successContainer: { margin: '12px 24px', padding: '12px 14px', backgroundColor: '#f0fff4', borderRadius: '12px', border: '1px solid #c6f6d5', display: 'flex', gap: '10px', alignItems: 'center' },
  successIcon: { color: '#38a169' }
};
// ==================== STYLES ORIGINAUX CONSERVÉS ====================
const styles = {
  page: { minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
  imageContainer: { height: '100%', minHeight: '100vh', backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative' },
  imageOverlay: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(135deg, rgba(41, 128, 185, 0.1) 0%, rgba(52, 152, 219, 0.1) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem' },
  heroContent: { maxWidth: '600px', color: 'white', textAlign: 'center' },
  logoContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', marginBottom: '2rem' },
  logoWrapper: { background: 'white', padding: '1rem', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100px', height: '100px' },
  logoImage: { width: '100%', height: '100%', objectFit: 'contain' },
  heroTitle: { fontSize: '3.5rem', fontWeight: '800', margin: 0, letterSpacing: '-0.5px', color: '#ffffff' },
  heroSubtitle: { fontSize: '1.5rem', opacity: 0.95, marginBottom: '1.5rem', fontWeight: '300', color: '#f8f9fa' },
  highlight: { color: '#f1c40f', fontWeight: '600' },
  heroDescription: { fontSize: '1.1rem', opacity: 0.9, marginBottom: '2rem', lineHeight: 1.6, color: '#ecf0f1' },
  card: { border: 'none', borderRadius: '0', height: '100vh', boxShadow: 'none', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' },
  cardHeader: { borderBottom: '1px solid #e0e7ef', padding: '2rem 2rem 1.5rem', backgroundColor: '#3498db', flexShrink: 0 },
  cardBody: { padding: '2rem', backgroundColor: 'white', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden' },
  cardFooter: { borderTop: '1px solid #e9ecef', padding: '1.5rem', backgroundColor: 'white' },
  loginCard: { border: 'none', borderRadius: '0', height: '100vh', boxShadow: 'none', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' },
  loginCardHeader: { borderBottom: '1px solid #e9ecef', padding: '1.5rem 1.5rem 1rem', backgroundColor: 'white', flexShrink: 0 },
  loginCardBody: { padding: '1.5rem', backgroundColor: 'white', flex: 1, overflowY: 'auto' },
  loginCardFooter: { padding: '1rem 1.5rem', borderTop: '1px solid #e9ecef', backgroundColor: 'white' },
  userSelectionMinimal: { display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '0.5rem' },
  userChoiceMinimalAgent: { background: 'rgba(52, 152, 219, 0.05)', border: '2px solid rgba(52, 152, 219, 0.15)', borderRadius: '12px', padding: '1rem 1.25rem', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', position: 'relative', overflow: 'hidden' },
  userChoiceMinimalUser: { background: 'rgba(46, 204, 113, 0.05)', border: '2px solid rgba(46, 204, 113, 0.15)', borderRadius: '12px', padding: '1rem 1.25rem', cursor: 'pointer', transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)', position: 'relative', overflow: 'hidden' },
  choiceHeader: { display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between' },
  choiceIconWrapperAgent: { width: '44px', height: '44px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: 'rgba(52, 152, 219, 0.1)', border: '1px solid rgba(52, 152, 219, 0.2)' },
  choiceIconWrapperUser: { width: '44px', height: '44px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: 'rgba(46, 204, 113, 0.1)', border: '1px solid rgba(46, 204, 113, 0.2)' },
  choiceIconAgent: { fontSize: '1.5rem', color: '#2980b9' },
  choiceIconUser: { fontSize: '1.5rem', color: '#27ae60' },
  choiceLabels: { flex: 1, display: 'flex', flexDirection: 'column', gap: '0.1rem', minWidth: 0 },
  choiceTitle: { fontSize: '1rem', fontWeight: '700', color: '#1e293b', lineHeight: 1.2 },
  choiceSubtitle: { fontSize: '0.8rem', color: '#475569', fontWeight: '500', lineHeight: 1.2 },
  choiceArrowAgent: { fontSize: '1.1rem', color: '#3498db', opacity: 0.9, transition: 'all 0.2s ease', flexShrink: 0 },
  choiceArrowUser: { fontSize: '1.1rem', color: '#2ecc71', opacity: 0.9, transition: 'all 0.2s ease', flexShrink: 0 },
  title: { fontSize: '2rem', fontWeight: '700', color: '#ffffff', marginBottom: '0.5rem' },
  subtitle: { fontSize: '1rem', color: '#e2e8f0' },
  formGroup: { marginBottom: '1.5rem' },
  formLabel: { display: 'flex', alignItems: 'center', fontSize: '0.9rem', fontWeight: '600', color: '#1e293b', marginBottom: '0.5rem' },
  inputIcon: { marginRight: '8px', fontSize: '16px', color: '#64748b' },
  formInput: { padding: '0.75rem 1rem', borderRadius: '8px', border: '2px solid #e2e8f0', fontSize: '0.95rem', transition: 'all 0.3s ease', width: '100%', paddingRight: '50px', color: '#0f172a' },
  passwordInputWrapper: { position: 'relative', width: '100%' },
  togglePasswordButton: { position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', padding: '6px 8px', background: 'transparent', border: 'none', color: '#64748b', zIndex: 10, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '36px', width: '36px' },
  togglePasswordIcon: { fontSize: '16px', opacity: 0.8 },
  loginTitle: { fontSize: '1.5rem', fontWeight: '600', color: '#0f172a', marginBottom: '0.25rem' },
  loginSubtitle: { fontSize: '0.9rem', color: '#475569' },
  loginHeaderContent: { display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1rem' },
  backButton: { color: '#475569', textDecoration: 'none', fontSize: '0.9rem', display: 'flex', alignItems: 'center', padding: 0 },
  userTypeIndicatorCompact: { width: '40px', height: '40px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '1.2rem' },
  alertMessage: { borderRadius: '8px', marginBottom: '1.5rem', border: 'none' },
  alertHeading: { fontSize: '0.95rem', fontWeight: '600', marginBottom: '0.25rem', color: '#991b1b' },
  alertText: { fontSize: '0.85rem', marginBottom: 0, color: '#1e293b' },
  successIcon: { fontSize: '2rem', color: '#15803d', marginTop: '0.5rem' },
  loginButton: { width: '100%', padding: '0.75rem', fontSize: '1rem', fontWeight: '600', borderRadius: '8px', border: 'none', transition: 'all 0.3s ease', marginBottom: '1rem', color: '#ffffff' },
  loginHeroContent: { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: '600px', padding: '2rem', textAlign: 'center', color: 'white' },
  loginHeroIcon: { fontSize: '4rem', marginBottom: '1.5rem', color: '#ffffff' },
  loginHeroTitle: { fontSize: '2.5rem', fontWeight: '600', marginBottom: '1rem', color: '#ffffff' },
  loginHeroSubtitle: { fontSize: '1.2rem', opacity: 0.95, marginBottom: '2.5rem', color: '#f8fafc' },
  featuresList: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', marginTop: '2rem' },
  featureItemLogin: { display: 'flex', alignItems: 'center', gap: '1rem', fontSize: '1.1rem', opacity: 0.95, padding: '0.75rem', backgroundColor: 'rgba(255,255,255,0.15)', borderRadius: '25px', backdropFilter: 'blur(10px)', transition: 'all 0.3s ease', width: 'fit-content', color: '#ffffff' },
  featureIconLogin: { fontSize: '1.2rem', color: '#f1c40f' },
  securitySection: { marginBottom: '1rem' },
  securityDetails: { paddingLeft: '0.25rem' },
  securityItem: { display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.4rem' },
  securityDot: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#16a34a' },
  securityText: { fontSize: '0.8rem', color: '#475569' },
  securityInfo: { display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#475569', fontSize: '0.85rem' },
  securityIconFooter: { fontSize: '1rem', color: '#16a34a' },
  securityTextFooter: { color: '#475569' },
  forgotPasswordLink: { fontSize: '0.8rem', color: '#3498db', textDecoration: 'none', transition: 'color 0.2s ease' }
};

const styleSheet = document.createElement("style");
styleSheet.innerText = `
  @keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
  .country-card-animated { animation: fadeInUp 0.4s ease-out forwards; opacity: 0; transform: translateY(10px); }
  .country-card-animated:hover { transform: translateX(6px); border-color: #3498db !important; box-shadow: 0 6px 16px rgba(52,152,219,0.15); }
  .country-card-animated:hover .country-arrow { transform: translateX(4px); color: #3498db !important; }
  .user-choice-minimal-agent:hover { background: rgba(52,152,219,0.1); border-color: #3498db; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(52,152,219,0.1); }
  .user-choice-minimal-user:hover { background: rgba(46,204,113,0.1); border-color: #2ecc71; transform: translateY(-2px); box-shadow: 0 8px 20px rgba(46,204,113,0.1); }
  input:focus { border-color: #3498db !important; box-shadow: 0 0 0 2px rgba(52,152,219,0.1) !important; outline: none; }
  .login-button:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(52,152,219,0.3); }
`;
document.head.appendChild(styleSheet);